import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../services/api'; // Yeni api.js dosyamızı import ettik
import '../styles/NewPassword.css';

function NewPassword() {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  const { token } = useParams(); // URL'den token'ı alıyoruz

  React.useEffect(() => {
    console.log("URL'den gelen token:", token);
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setError('Şifreler eşleşmiyor');
      return;
    }

    if (newPassword.length < 6) {
      setError('Şifre en az 6 karakter olmalıdır');
      return;
    }

    try {
      const response = await api.post('/reset-password/reset-password', { token, newPassword });
      if (response.status === 200) {
        setSuccess(true);
        setTimeout(() => {
          navigate('/login'); // Başarılı olunca login sayfasına yönlendir
        }, 2000);
      }
    } catch (error) {
      console.error('Error resetting password:', error);
      setError('Şifre sıfırlanırken bir hata oluştu. Lütfen tekrar deneyin.');
    }
  };

  return (
    <div className="new-password-page">
      <div className="new-password-container">
        <h2>Yeni Şifre Belirleme</h2>

        {success ? (
          <div className="success-message">
            <p>Şifreniz başarıyla güncellendi!</p>
            <p>Giriş sayfasına yönlendiriliyorsunuz...</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <input
              type="password"
              placeholder="Yeni şifre"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
            <input
              type="password"
              placeholder="Yeni şifreyi tekrar girin"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            {error && <div className="error-message">{error}</div>}

            <button type="submit" className="submit-button">
              Şifreyi Güncelle
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default NewPassword;